export default __webpack_public_path__ + "static/media/whitePaper.32fb572e.pdf";